import { broadcast, broadcastChannels } from '@common/helpers/broadcast';
import {
  FinishCollectDepositMoney,
  GetPlayerInfo,
  GetWithdrawalRequests,
  PayWithdrawalRequest,
  StartCollectDepositMoney,
} from '../actions/clientTransaction';
import { store } from '../index/terminalApp';

export const getPlayerInfo = (data) => new Promise((resolve) => {
  store.dispatch(GetPlayerInfo(data));
  const result = {};

  broadcast.addEventListener(
    broadcastChannels.ReceivePlayerInfo,
    (e) => {
      result.playerInfo = e.detail;
      resolve(result);
    },
    { once: true },
  );
});

export const startCollectDepositMoney = (receiveCb) => {
  let amount = null;

  store.dispatch(StartCollectDepositMoney());

  const onRecieve = (e) => {
    amount = e.detail;
    receiveCb(e.detail);
  };

  broadcast.addEventListener(broadcastChannels.ReceiveCollectedAmount, onRecieve);

  const finish = () => {
    broadcast.removeEventListener(broadcastChannels.ReceiveCollectedAmount, onRecieve);
  };

  return finish;
};

export class HandleStartFinish {
  static started = false;

  static start = (receiveCb) => {
    this.started = true;
    return startCollectDepositMoney(receiveCb);
  };

  static finish = () => {
    if (!this.started) return;
    this.started = false;
    return store.dispatch(FinishCollectDepositMoney());
  };
}

export const getWithdrawalRequests = (playerId) => new Promise((resolve) => {
  store.dispatch(GetWithdrawalRequests({ playerId }));
  broadcast.addEventListener(broadcastChannels.ReceiveWithdrawalRequests, (e) => resolve(e.detail), { once: true });
});

export const payWithdrawalRequest = (requestId, pin) => new Promise((resolve) => {
  store.dispatch(PayWithdrawalRequest({ requestId, pin }));

  broadcast.addEventListener(
    broadcastChannels.ReceiveIsWithdrawalPinValid,
    (e) => {
      resolve({
        isSuccess: e.detail,
        errorMessage: e.detail ? '' : 'Wrong passkey',
      });
    },
    { once: true },
  );

  broadcast.addEventListener(
    broadcastChannels.ReceiveIsWithdrawalState,
    (e) => {
      resolve({
        isSuccess: e.detail,
        errorMessage: e.detail ? '' : 'Withdraw failed',
      });
    },
    { once: true },
  );
});
